import {Dispatch, SetStateAction} from 'react';
import {trackError} from './analytics-provider';
import {sanitizeForLog, safeConsoleError} from './sanitize';

export function isAbortError(error: Error) {
    const abortedKeywords = ['aborted', 'abort', 'cancel', 'cancelled', 'interrupted', 'interrupt', 'stop', 'stopped'];
    return abortedKeywords.some(keyword => error.message?.toLowerCase().includes(keyword));
}

export default function handleError(error: Error, setError: Dispatch<SetStateAction<string>> | ((s: string) => void) | null) {
    if (isAbortError(error)) {
        return;
    }

    if (process.env.REACT_APP_API_BASE !== 'test-api') {
        safeConsoleError(error.message);
        if (error.stack) {
            safeConsoleError(error.stack);
        }
    }
    setError && setError('An error has occurred');

    // Sanitize error for server-side logging to prevent CRLF injection
    const sanitizedError = new Error(sanitizeForLog(error.message));
    sanitizedError.name = sanitizeForLog(error.name);
    sanitizedError.stack = error.stack ? sanitizeForLog(error.stack) : undefined;

    //Track error in our analytics provider
    trackError(sanitizedError);
}